import React from "react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import getInTouch from "../assets/getintouch.png";
import aboutBanner2 from "../assets/about_banner2.png";
import pdf from "../assets/projects.pdf";
import FlagshipProjects from "../components/FlagshipProjects";
import { Link } from "react-router-dom";

const Projects = () => {
  return (
    <div>
      <Header />
      <div className="relative w-full">
        {/* Banner Image */}
        <img
          src={aboutBanner2}
          alt="aboutBanner"
          className="w-full h-auto object-cover banner-img"
        />

        {/* Overlay Text */}
        <div className="absolute inset-0 flex items-center justify-center">
          <h2
            data-aos="fade-up"
            className="text-white text-4xl md:text-5xl  title-font-heading"
          >
            Our Projects
          </h2>
        </div>
      </div>
      <FlagshipProjects />

      {/* Additonal Project */}

      <h2 className="addti">Addtional Projects</h2>
      <div className="container mx-auto mb-5">
        <table className="w-full border-collapse text-start">
          <thead>
            <tr className="bg-white text-black border-b">
              <th className="th-title">Sr. No.</th>
              <th className="th-title">Project Name</th>
              <th className="th-title">Location</th>
            </tr>
          </thead>
          <tbody>
            {[
              {
                sr: 1,
                name: "Arham heights",
                location: "GOREGAON (W)",
              },
              { sr: 2, name: "Shreeview", location: "Charni Road (W)" },
              { sr: 3, name: "Anupam Properties", location: "Grant Road (E)" },
              { sr: 4, name: "Shakuntala Sadan", location: "Charni Road (W)" },
              { sr: 5, name: "Shelton Group Tower", location: "Kapolwadi (W)" },
            ].map((project, idx) => (
              <tr key={idx} className={idx % 2 === 0 ? "bg-[#EDF3FF]" : ""}>
                <td className="py-4 px-4 td-width">{project.sr}</td>
                <td className="py-4 px-4 td-width">{project.name}</td>
                <td className="py-4 px-4 td-width">{project.location}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <h2 className="text-center font-sts">& many more</h2>
        <div className="text-center">
          <a className="btn-portfolio" target="_blank" download={true} href={pdf}>
            Our Portfolio
          </a>
        </div>
      </div>

      {/* Get in Touch */}
      <section className="bg-[#1C3E9A] text-white mt-20 px-6 main-cta-card md:px-28">
        <div className="col-flex flex flex-col md:flex-row items-center justify-between">
          {/* Left: Text */}
          <div className="md:w-1/2 text-center md:text-left cta-headong">
            <h3 data-aos="fade-up">Get in Touch</h3>
            <h2 data-aos="fade-up">
              Time to take action? <br className="hidden md:block" />
              Get a quote today
            </h2>
            <Link to="/contact">
              <button
                data-aos="fade-up"
                className="uppercase bg-white text-[#1C3E9A] px-6 py-2 mt-6 rounded-full"
              >
                Get a Quote
              </button>
            </Link>
          </div>

          {/* Right: Image */}
          <div className="md:w-1/2 mt-8 md:mt-0 flex justify-center">
            <img
              data-aos="zoom-in-up"
              src={getInTouch}
              alt="Engineers"
              className="h-90 w-100 object-contain"
            />
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Projects;
